module.exports = __webpack_public_path__ + "64de2e070cd54051aff7a15241e30fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/assets/logo.png
// module id = 1046
// module chunks = 0